import { z } from 'zod';

export const vacancyBoardFilterSchema = z.object({
    Sectors: z.string().optional(), 
    Countries: z.string().optional(), 
    Donors: z.string().optional(),
    OtherDonors: z.string().optional()
});